import { useAuth } from "./Auth";


const useNotification = () => {
  const { sendNotification } = useAuth();
  
  // Job Notifications
  const notifyJobAccepted = (technician, clientId, jobId) => {
    return sendNotification(clientId, {
      type: 'job_accepted',
      title: 'Job Accepted',
      body: `${technician.name} accepted your job request`,
      jobId,
      senderId: technician.id,
      senderName: technician.name
    });
  };

  const notifyJobCompleted = (technician, clientId, jobId) => {
    return sendNotification(clientId, {
      type: 'job_completed',
      title: 'Job Completed',
      body: `${technician.name} marked the job as completed`,
      jobId,
      senderId: technician.id,
      senderName: technician.name
    });
  };

  const notifyJobCancelled = (whoCancelled, otherUserId, jobId) => {
    return sendNotification(otherUserId, {
      type: 'job_cancelled',
      title: 'Job Cancelled',
      body: `${whoCancelled.name} cancelled the job`,
      jobId,
      senderId: whoCancelled.id,
      senderName: whoCancelled.name
    });
  };

  const notifyJobInProgress = (technician, clientId, jobId) => {
    return sendNotification(clientId, {
      type: 'job_in_progress',
      title: 'Job Started',
      body: `${technician.name} started working on your job`,
      jobId,
      senderId: technician.id,
      senderName: technician.name
    });
  };

  const notifyJobRejected = (technician, clientId, jobId) => {
    return sendNotification(clientId, {
      type: 'job_rejected',
      title: 'Job Rejected',
      body: `${technician.name} rejected your job request`,
      jobId,
      senderId: technician.id,
      senderName: technician.name
    });
  };

  const notifyJobPending = (clientId, jobId) => {
    return sendNotification(clientId, {
      type: 'job_pending',
      title: 'Job Pending',
      body: 'Your job request is awaiting acceptance',
      jobId
    });
  };

  // Chat Notifications
  const notifyNewMessage = (sender, recipientId, jobId) => {
    return sendNotification(recipientId, {
      type: 'chat_message',
      title: 'New Message',
      body: `You have a new message from ${sender.name}`,
      jobId,
      senderId: sender.id,
      senderName: sender.name
    });
  };

  // Wallet Notifications
  const notifyWalletCredit = (userId, amount) => {
    return sendNotification(userId, {
      type: 'wallet_credit',
      title: 'Wallet Credited',
      body: `₦${amount.toLocaleString()} was added to your wallet`,
      amount: amount
    });
  };

  const notifyWalletDebit = (userId, amount) => {
    return sendNotification(userId, {
      type: 'wallet_debit',
      title: 'Wallet Debited',
      body: `₦${amount.toLocaleString()} was deducted from your wallet`,
      amount: amount
    });
  };

  return {
    notifyJobAccepted,
    notifyJobCompleted,
    notifyJobCancelled,
    notifyJobInProgress,
    notifyJobRejected,
    notifyJobPending,
    notifyNewMessage,
    notifyWalletCredit,
    notifyWalletDebit
  };
};

export default useNotification;